import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
const Response = z.object({
    data: z.object({}),
});
export const url = (tradeProposalBundleId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/investment/trade-proposal-bundles/${tradeProposalBundleId}:submit`
    : `https://middleware.uat.farther.com/investment/trade-proposal-bundles/${tradeProposalBundleId}:submit`;
export const postTradeProposalBundleSubmit = async (tradeProposalBundleId, config) => {
    const { data } = await axios.post(url(tradeProposalBundleId), null, {
        headers: {
            version: "20241111",
            "Content-Type": "application/json",
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            ["idempotency-key"]: `TradeProposalBundle:Submit:${tradeProposalBundleId}`, // Should only be able to submit the bundle once
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return;
    }
    const errorMessage = `[postTradeProposalBundleSubmit.ts] received unexpected data`;
    errorLog(errorMessage, decoded.error.message);
    throw new ValidationError(errorMessage, decoded.error.issues);
};
//# sourceMappingURL=postTradeProposalBundleSubmit.js.map